import './consentDemo.css';

// Static animated mockup of the Google consent screen. Purely decorative —
// primes the user to check both consent boxes on the real screen next.
// Ported verbatim from apps/inboxcart/public/index.html:353-365.
export function ConsentDemo() {
  return (
    <div className="prime-demo">
      <div className="pd-head">
        <svg width="14" height="14" viewBox="0 0 18 18" aria-hidden="true">
          <path
            d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
            fill="#4285F4"
          />
          <path
            d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
            fill="#34A853"
          />
          <path
            d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332z"
            fill="#FBBC05"
          />
          <path
            d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 6.293C4.672 4.166 6.656 3.58 9 3.58z"
            fill="#EA4335"
          />
        </svg>{' '}
        Sign in with Google
      </div>
      <div className="pd-body">
        <div className="pd-mark">a</div>
        <div className="pd-title">Ario wants access to your Google Account</div>
        <div className="pd-acct">
          <span className="pd-av">a</span> testabc@gmail.com
        </div>
        <div className="pd-info">
          <p>
            If you allow Ario access to your Gmail data, Google will ask you to
            review their access every 6 months.
          </p>
          <div className="pd-checkrow">
            <span className="prime-box prime-box1">
              <svg className="ck" viewBox="0 0 24 24">
                <path d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span>
              I want to allow Ario ongoing access to the Google Account data I'm
              sharing today
            </span>
          </div>
        </div>
        <div className="pd-select">
          Select what <b style={{ color: '#1a73e8' }}>Ario</b> can access
        </div>
        <div className="pd-scoperow">
          <svg className="pd-gmail" viewBox="0 0 24 24">
            <path
              fill="#EA4335"
              d="M2 6.5C2 5.7 2.7 5 3.5 5L12 11l8.5-6c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5H20V9l-8 5.6L4 9v9H3.5C2.7 18.5 2 17.8 2 17V6.5z"
            />
          </svg>
          <span className="pd-scopetext">
            View your email messages and settings
          </span>
          <span className="prime-box prime-box2">
            <svg className="ck" viewBox="0 0 24 24">
              <path d="M5 13l4 4L19 7" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
}
